import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import Text from 'UIKit/Text'
import { UserBonus } from 'config/types/bonus/userBonus'
import { Icons } from 'svgs'
import { colors } from 'theme/colors'
import { ValidatedBonusStatusEnums, useValidateBonus } from 'views/BonusCenter/hooks'
import BonusInvalidMessage from './BonusInvalidMessage'

interface BonusInvalidProps {
  bonus: UserBonus
}

const BonusInvalid: React.FC<BonusInvalidProps & BoxProps> = ({ bonus, ...props }) => {
  const validatedResult: ValidatedBonusStatusEnums = useValidateBonus(bonus)

  return (
    <Box background="rgba(255, 255, 255, 0.04) !important" {...props} width="100%">
      <Flex alignItems="center" p="8px 12px !important" height="100%" mx="auto">
        <Box width="16px" height="16px">
          {validatedResult === ValidatedBonusStatusEnums.Used ||
          validatedResult === ValidatedBonusStatusEnums.Claimed ? (
            <Icons.SuccessIcon width="16px" fill={colors.success} />
          ) : (
            <Icons.CloseCircleIcon width="16px" fill={colors.error} />
          )}
        </Box>

        <Text fontSize="12px" color="textTertiary" fontWeight="300" ml="4px" style={{ whiteSpace: 'break-spaces' }}>
          <BonusInvalidMessage bonus={bonus} />
        </Text>
      </Flex>
    </Box>
  )
}

export default BonusInvalid
